import { ChangeDetectionStrategy, OnInit, Component, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { ViewerModel } from "../../../models/viewer-model";
import { E5coreUiAttachmentViewerBaseComponent } from "./e5core-ui-attachment-viewer-base";
import { E5ConfigurationService, ConfigurationScopeService } from "e5core-angular-services";

@Component({
    selector: 'e5core-ui-e5-attachment-viewer',
    template: `
    <span *ngIf="1==+behaviourType">
    <iframe *ngIf="!(attachmentUrl == '')" [src]="attachmentUrl | safe"></iframe>
    </span>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ {provide: E5coreUiAttachmentViewerBaseComponent, useExisting: E5coreUiE5AttachmentViewerComponent }]
})
export class E5coreUiE5AttachmentViewerComponent extends E5coreUiAttachmentViewerBaseComponent implements AfterViewInit, OnInit {

    constructor(public e5ConfigurationService : E5ConfigurationService, public configurationScopeService : ConfigurationScopeService, public changeDetectorRef: ChangeDetectorRef) 
    {
        super(e5ConfigurationService, changeDetectorRef);
    }

    ngOnInit() {
    }
      
    ngAfterViewInit() {
    }
    

    public constructViewerUrl(viewerModel : ViewerModel, nextFunction : Function) : void {
        //  "DocAttachmentId":"36",
        //  "DocName":"Sleepy.jpg",
        //  "DocUrl":"http://vlane5dev2016:81/sites/e5dev/e5%20Attachments/2/Sleepy.jpg",
        //  "WorkItemId":"7657fec3-1e74-11e7-a2c4-00155d2aaa1d",
        //  "Extension":"jpg",
        //  "DocTypeId":2,
        //  "DocId":2005,
        //  "DocTypeName":"Public Images"

        // format URL e.g.
        // "/sites/travel/_layouts/e5/WorkAttachmentViewer.aspx?id=6da5fd96-5462-11e6-815d-90e2ba57fbe1&source=FindWork&auto=false&attachments=6da5fd96-5462-11e6-815d-90e2ba57fbe1;23319|"
        // WorkAttachmentViewer.aspx?id=13a11814-1efb-11e7-8144-000d3aa0265d&source=FindWork&auto=false&attachments=13a11814-1efb-11e7-8144-000d3aa0265d;17627|

        this.configurationScopeService.get(this.e5ConfigurationService.settings.apiServer.scope).subscribe(
            s => {

                var documentStoreBaseUrl = s.siteUrl;
                var attachmentIdUrlSegment = "";

                if (viewerModel.id != null)
                    attachmentIdUrlSegment = viewerModel.workId + ";" + viewerModel.id + "|" ;
                
                this.attachmentUrl = documentStoreBaseUrl + // e.g http://vlane5dev2016:81/sites/e5dev/
                "/_layouts/15/e5/WorkAttachmentViewer.aspx" +
                "?id=" + viewerModel.workId +
                "&source=FindWork&auto=false" +
                "&attachments=" + attachmentIdUrlSegment;

                if (nextFunction)
                    nextFunction(viewerModel, this.attachmentUrl);
            },
            error => {
                console.error(error);
            }
            )
    }

    public raiseEvent(viewerModel : ViewerModel) : void {
        this.viewerDisplayedEvent.emit({workId: viewerModel.workId, type: "E5SharepointAttachment", attachmentId: viewerModel.id, fullUrl: viewerModel.fullUrl, name: null});
    }
}